import { PageHeader } from 'antd';
import * as React from 'react';

export type ContractWriteTemplateProps = {
  children: React.ReactNode;
  extra?: React.ReactNode;
};

const ContractWriteTemplate = ({ children, extra }: ContractWriteTemplateProps) => {
  return (
    <>
      <PageHeader
        title="계약 등록"
        subTitle="신규 계약 정보를 등록합니다."
        style={{ background: '#fff', border: '1px solid rgb(235, 237, 240)' }}
        onBack={() => window.history.back()}
        extra={extra}
      >
        {children}
      </PageHeader>
    </>
  );
};

ContractWriteTemplate.defaultProps = {
  extra: undefined,
};

export default ContractWriteTemplate;
